import { IntegrationServices } from '@sequencehq/api/utils/commonEnums'
import { SimpleModal, Box } from '@sequencehq/core-components'
import { FC } from 'react'
import { GreyGrey80, Primary13Regular } from '@sequencehq/core-components'
import { getIntegrationName } from 'Integrations/utils/getIntegrationName'
import { useMutation } from '@sequencehq/api/utils'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useNotifications } from '@sequencehq/core-components'

const useUnlinkInvoiceModal = (props: {
  service: IntegrationServices
  invoiceId: string
}) => {
  const { displayNotification } = useNotifications()

  const unlinkingMutation = useMutation(
    dashboard20240730Client.deleteLinkedEntity
  )

  const serviceName = getIntegrationName(props.service)
  const onUnlink = async (): Promise<boolean> => {
    try {
      await unlinkingMutation.mutateAsync({
        type: 'INVOICE',
        id: props.invoiceId,
        service: props.service
      })
      displayNotification(`Invoice unlinked from ${serviceName}`, {
        type: 'success'
      })
      return true
    } catch {
      displayNotification(`Could not unlink invoice from ${serviceName}`, {
        type: 'error'
      })
      return false
    }
  }

  return { serviceName, onUnlink, unlinking: unlinkingMutation.isPending }
}

export const UnlinkInvoiceModal: FC<{
  invoiceId: string
  service: IntegrationServices
  onClose: () => void
}> = props => {
  const hook = useUnlinkInvoiceModal({
    service: props.service,
    invoiceId: props.invoiceId
  })

  return (
    <SimpleModal
      isOpen
      variant="dialog"
      onClose={props.onClose}
      data-testid="modal.unlinkInvoice"
      title={`Unlink Invoice from ${hook.serviceName}`}
      isDestructive
      disableSubmitOnEnter
      submitButtonText="Unlink"
      submittingButtonText="Unlinking..."
      cancelButtonText="Cancel"
      submitting={hook.unlinking}
      onSubmit={hook.onUnlink}
    >
      <Box color={GreyGrey80} {...Primary13Regular} flex={1}>
        This will unlink the invoice from {hook.serviceName} immediately. You
        can re-link the invoice again if required.
      </Box>
    </SimpleModal>
  )
}
